var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowthIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "#11AB1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 42.5H16.9C16.0599 42.5 15.6399 42.5 15.319 42.3365C15.0368 42.1927 14.8073 41.9632 14.6635 41.681C14.5 41.3601 14.5 40.9401 14.5 40.1V15.5M41.5 21.5L33.3485 29.6515C33.0515 29.9485 32.903 30.097 32.7318 30.1526C32.5811 30.2016 32.4189 30.2016 32.2682 30.1526C32.097 30.097 31.9485 29.9485 31.6515 29.6515L28.8485 26.8485C28.5515 26.5515 28.403 26.403 28.2318 26.3474C28.0811 26.2984 27.9189 26.2984 27.7682 26.3474C27.597 26.403 27.4485 26.5515 27.1515 26.8485L20.5 33.5M41.5 21.5H35.5M41.5 21.5V27.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthIcon);
export default __webpack_public_path__ + "static/media/growth_icon.5fcc4ac1f8bcb2e82b93b152416dcc7e.svg";
export { ForwardRef as ReactComponent };